import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading } from "../slices/holidaySlice";
import * as services from "../services/configBesmartApi";
import { generateRandomString } from "utils/helper";
import { setAllBesmart } from "../slices/attendanceSlice";
import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";

function useAllBesmart() {
  const dispatch = useDispatch();
  const { currentCompany, currentEmployee, } = useSelector((state) => state.company);
  const { allBesmart } = useSelector((state) => state.attendance);
  const { t } = useTranslation();

  function toInitialValues(data = {}) {
    const submenu = data?.[0]?.submenu || [];
    const modifiedValues = {
      menuCodeBesmart: data?.[0]?.statusFlag === "Y",
      switchbenefit: submenu.find(m => m.menuCode === "BENEFIT")?.statusFlag === "Y",
      switchbeperform: submenu.find(m => m.menuCode === "BEPERFORM")?.statusFlag === "Y",
      switchbefindmyteam: submenu.find(m => m.menuCode === "BEFINDMYTEAM")?.statusFlag === "Y",
      switchbetimesheet: submenu.find(m => m.menuCode === "BETIMESHEET")?.statusFlag === "Y",
      switchbepocket: submenu.find(m => m.menuCode === "BEPOCKET")?.statusFlag === "Y",
      switchbematch: submenu.find(m => m.menuCode === "BEMATCH")?.statusFlag === "Y",
      switchbetrain: submenu.find(m => m.menuCode === "BETRAIN")?.statusFlag === "Y",
    };

    return modifiedValues;
  }
  function toParams(values = {}, menuList = []) {
    const ALLBeMenu = menuList.find(menu => menu.menuCode === "ALLMENU");
    const newSubmenu = [
      { menuCode: "BENEFIT", statusFlag: values.switchbenefit ? "Y" : "N", index: 0 },
      { menuCode: "BEPERFORM", statusFlag: values.switchbeperform ? "Y" : "N", index: 1 },
      { menuCode: "BEFINDMYTEAM", statusFlag: values.switchbefindmyteam ? "Y" : "N", index: 2 },
      { menuCode: "BETIMESHEET", statusFlag: values.switchbetimesheet ? "Y" : "N", index: 3 },
      { menuCode: "BEPOCKET", statusFlag: values.switchbepocket ? "Y" : "N", index: 4 },
      { menuCode: "BEMATCH", statusFlag: values.switchbematch ? "Y" : "N", index: 5 },
      { menuCode: "BETRAIN", statusFlag: values.switchbetrain ? "Y" : "N", index: 6 },
    ];

    return {
      id: ALLBeMenu?.id || null,
      menuCode: "ALLMENU",
      statusFlag: values?.menuCodeBesmart ? "Y" : "N",
      index: ALLBeMenu?.index ?? 0,
      submenu: newSubmenu,
    };
  }
  const getAllBesmart = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getBesmartConfig({
        requestId: generateRandomString(),
        configType: "ALLMENU",
        companyId: currentCompany,
        actionId: currentEmployee,
      });
      dispatch(setAllBesmart(response.data?.content));
    } catch (error) {
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);

  const initialValues = useMemo(() => {
    return toInitialValues(allBesmart);
  }, [allBesmart]);

  const editAllBesmart = useCallback(
    async (values) => {
      Modal.confirm({
        title: t("dialog.confirmation.header"),
        content: (
          <span>{t("dialog.confirmation.edit_action")}</span>
        ),
        async onOk() {
          try {
            dispatch(setIsLoading(true));

            const menuList = allBesmart || [];
            const params = toParams(values, menuList);

            await services.editBesmartConfig({
              requestId: generateRandomString(),
              companyId: currentCompany,
              actionId: currentEmployee,
              menuList: params,
            });
            message.success(t("common.successsfull"));
            getAllBesmart();
          } catch (error) {
            console.error(error);
          } finally {
            dispatch(setIsLoading(false));
          }
        },
      });
    },
    [
      currentCompany,
      currentEmployee,
      allBesmart,
      dispatch,
      getAllBesmart,
      t,
    ]
  );

  useEffect(() => {
    getAllBesmart();
  }, [getAllBesmart]);

  return {
    getAllBesmart,
    allBesmart,
    initialValues,
    editAllBesmart
  };
}

export default useAllBesmart;